/* ════════════════════════════════════════════════════════════
   Flux Labs — visitor & funnel tracker
   Add to every page:  <script src="/flux-analytics.js" defer></script>
   Sends: pageview, add_to_cart, begin_checkout, purchase
   No cookies. No personal data. Session id only.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SUPABASE_URL = 'https://bwgvqblfjmxbpuyzjdki.supabase.co';
  var SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ3Z3ZxYmxmam14YnB1eXpqZGtpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIyMzc4NDksImV4cCI6MjA5NzgxMzg0OX0.x3msVmw_Q8VRZebWa6cydFxjYGKt2JckT4RFMcxjcF8';
  var ENDPOINT = SUPABASE_URL + '/rest/v1/analytics_events';
  var PRESENCE = SUPABASE_URL + '/rest/v1/presence';

  /* ── session id ─────────────────────────────────────────── */
  function sid() {
    try {
      var s = sessionStorage.getItem('flux_sid');
      if (!s) {
        s = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        sessionStorage.setItem('flux_sid', s);
      }
      return s;
    } catch (e) { return 'nostorage'; }
  }

  /* ── helpers ────────────────────────────────────────────── */
  function qp(name) {
    try { return new URLSearchParams(location.search).get(name) || null; }
    catch (e) { return null; }
  }

  function device() {
    var w = window.innerWidth || 0;
    if (w && w < 768) return 'mobile';
    if (w && w < 1200) return 'tablet';
    return 'desktop';
  }

  function cartState() {
    try {
      var c = JSON.parse(localStorage.getItem('fluxCart') || '[]');
      if (!Array.isArray(c)) return { count: 0, value: 0 };
      var count = 0, value = 0;
      for (var i = 0; i < c.length; i++) {
        var q = Number(c[i].qty) || 0;
        var p = Number(c[i].price) || 0;
        count += q;
        value += q * p;
      }
      return { count: count, value: Math.round(value * 100) / 100 };
    } catch (e) { return { count: 0, value: 0 }; }
  }

  /* ── send ───────────────────────────────────────────────── */
  function send(event, extra) {
    var cart = cartState();
    var row = {
      session_id: sid(),
      event: event,
      page: location.pathname + location.hash,
      referrer: document.referrer || null,
      utm_source: qp('utm_source'),
      utm_medium: qp('utm_medium'),
      utm_campaign: qp('utm_campaign'),
      device: device(),
      cart_count: cart.count,
      cart_value_aed: cart.value
    };
    if (extra) for (var k in extra) if (extra[k] !== undefined) row[k] = extra[k];

    var body = JSON.stringify([row]);
    var headers = {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_ANON,
      'Authorization': 'Bearer ' + SUPABASE_ANON,
      'Prefer': 'return=minimal'
    };

    try {
      fetch(ENDPOINT, { method: 'POST', headers: headers, body: body, keepalive: true })
        .catch(function () {});
    } catch (e) {}
  }

  /* ── 1. pageview ────────────────────────────────────────── */
  send('pageview');

  /* ── 2. live presence heartbeat (every 20s) ─────────────── */
  function beat() {
    try {
      fetch(PRESENCE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON,
          'Authorization': 'Bearer ' + SUPABASE_ANON,
          'Prefer': 'resolution=merge-duplicates,return=minimal'
        },
        body: JSON.stringify([{ session_id: sid(), page: location.pathname, updated_at: new Date().toISOString() }]),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  beat();
  setInterval(beat, 20000);

  /* ── 3. add_to_cart — watch localStorage writes ─────────── */
  (function hookCart() {
    var last = cartState().count;
    var origSet = localStorage.setItem;

    function check(prevSnapshot) {
      var now = cartState();
      if (now.count > last) {
        var added = now.count - last;
        var name = null, variant = null, price = null;
        try {
          var cur = JSON.parse(localStorage.getItem('fluxCart') || '[]');
          var prev = prevSnapshot || [];
          // newest item = one not in prev, else last in list
          var found = null;
          for (var i = cur.length - 1; i >= 0; i--) {
            var match = prev.filter(function (p) {
              return p.name === cur[i].name && p.variant === cur[i].variant && p.qty === cur[i].qty;
            });
            if (!match.length) { found = cur[i]; break; }
          }
          if (!found && cur.length) found = cur[cur.length - 1];
          if (found) { name = found.name || null; variant = found.variant || null; price = Number(found.price) || null; }
        } catch (e) {}

        send('add_to_cart', { product: name, variant: variant, qty: added, value_aed: price });
      }
      last = now.count;
    }

    try {
      localStorage.setItem = function (key, val) {
        var prevSnapshot = null;
        if (key === 'fluxCart') {
          try { prevSnapshot = JSON.parse(localStorage.getItem('fluxCart') || '[]'); } catch (e) {}
        }
        origSet.apply(this, arguments);
        if (key === 'fluxCart') { setTimeout(function () { check(prevSnapshot); }, 0); }
      };
    } catch (e) {}

    // cross-tab / custom event fallback
    window.addEventListener('flux:cart', function () { setTimeout(function () { check(null); }, 0); });
    window.addEventListener('storage', function (e) { if (e.key === 'fluxCart') setTimeout(function () { check(null); }, 0); });
  })();

  /* ── 4. begin_checkout — wrap openCheckout() ────────────── */
  function wrapCheckout() {
    if (typeof window.openCheckout === 'function' && !window.openCheckout.__fluxWrapped) {
      var orig = window.openCheckout;
      window.openCheckout = function () {
        send('begin_checkout');
        return orig.apply(this, arguments);
      };
      window.openCheckout.__fluxWrapped = true;
      return true;
    }
    return false;
  }
  if (!wrapCheckout()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (wrapCheckout() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  // fallback: any click on a checkout button
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('#btnCheckout, .btn-checkout, [onclick*="openCheckout"]') : null;
    if (el && !el.__fluxSeen) { el.__fluxSeen = true; setTimeout(function () { el.__fluxSeen = false; }, 1500); send('begin_checkout'); }
  }, true);

  /* ── 5. purchase — success panel becomes visible ────────── */
  function watchSuccess() {
    var node = document.getElementById('checkoutSuccess');
    if (!node) return false;
    var fired = false;
    var mo = new MutationObserver(function () {
      var visible = node.offsetParent !== null && getComputedStyle(node).display !== 'none';
      if (visible && !fired) {
        fired = true;
        var c = cartState();
        send('purchase', { value_aed: c.value, qty: c.count });
      }
      if (!visible) fired = false;
    });
    mo.observe(node, { attributes: true, attributeFilter: ['style', 'class'] });
    return true;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSuccess);
  } else {
    watchSuccess();
  }

  /* ── manual API, if ever needed ─────────────────────────── */
  window.fluxTrack = send;
})();
